import { render } from "./OnScreenDebuggerVideoTab.vue?vue&type=template&id=350bd254&scoped=true&ts=true"
import script from "./OnScreenDebuggerVideoTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnScreenDebuggerVideoTab.vue?vue&type=script&setup=true&lang=ts"

import "./OnScreenDebuggerVideoTab.vue?vue&type=style&index=0&id=350bd254&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350bd254"],['__file',"src/components/OnScreenDebuggerVideoTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "350bd254"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('350bd254', __exports__)) {
    api.reload('350bd254', __exports__)
  }
  
  module.hot.accept("./OnScreenDebuggerVideoTab.vue?vue&type=template&id=350bd254&scoped=true&ts=true", () => {
    api.rerender('350bd254', render)
  })

}


export default __exports__